import { call, put } from "redux-saga/effects";
import { AxiosError, AxiosResponse } from "axios";

// Response / Request
import { Result } from "@models/common/resultResponse";
import { KeyValueEnum } from "@/main/models/common";

// Redux
import { GetCartStatus, saveCartStatus } from "./index";

// Api's
import { quoteSupplierItemStatusApi } from "../../api";
import { errorBoundaryReduxSaga, renderErrorReduxSaga } from "@/main/services/utils";

export function* getCartStatusSaga(action: GetCartStatus) {
	try {
		const response: AxiosResponse<Result<KeyValueEnum[]>> = yield call(
			quoteSupplierItemStatusApi.getDomain,
			action.payload.request,
		);

		if (response.data.result) {
			yield put(saveCartStatus(response.data.result, false, null));
		}
	} catch (exception) {
		if (exception instanceof AxiosError) {
			const resultError = errorBoundaryReduxSaga(exception);
			renderErrorReduxSaga(resultError);

			yield put(saveCartStatus(null, true, resultError.messagesDataError));
		}
	}
}
